module.exports = __webpack_public_path__ + "static/media/info.eb8aca31.svg";